/**
 * Log client-side errors to the server
 */

import $ from 'jquery'
import { trackJSError } from '../analytics/fpti'
import { getRecentActions } from '../../transfer/middlewares/action-history'

// max number of errors logged per session
const MAX_ERRORS = 2

// error count
let errors = 0

/**
 * post the messages to the server
 */
export function log({ url, message, file, line, column, error }) {
  // log to CAL
  $.post(url, {
    message: (error && error.message) || message,
    href: window.location.href,
    file: file,
    line: line,
    column: column,
    stack: error ? error.stack : '',
    userAgent: navigator.userAgent,
    history: getRecentActions(),
  })

  // log to FPTI
  trackJSError(error, `${file} ${line}:${column}`)
}

/**
 * Start capturing global errors
 * @param URL where we POST the errors
 */
export function startClientErrorTracking(url) {
  window.addEventListener('unhandledrejection', handleRejection)
  window.addEventListener('error', handleError)

  function handleRejection(event) {
    // avoid spamming the service if there are a lot of errors
    if (errors > MAX_ERRORS) {
      return
    }

    // attempt to extract reason from event
    let reason
    if (typeof event.reason === 'object' && event.reason) {
      // if it looks basically like an Error object, handle it
      reason = event.reason.stack || event.reason.message

      if (!reason) {
        try {
          reason = JSON.stringify(event.reason).substring(0, 255)
        } catch (e) {
          // object is cyclic, we can't log it..
        }
      }
    } else if (typeof event.reason === 'string') {
      reason = event.reason
    }
    // other types will be unhelpful in debugging, so ignore them

    // do not log empty reasons
    if (reason && reason !== '{}') {
      ++errors

      log({
        url,
        file: '',
        line: '',
        column: '',
        error: { message: 'unhandledRejection', stack: reason },
      })
    }
  }

  function handleError(event) {
    // avoid spamming the service if there are a lot of errors
    if (errors > MAX_ERRORS) {
      return
    }

    const {
      message,
      filename: file,
      lineno: line,
      colno: column,
      error,
    } = event

    // do not log empty errors
    if (message || (error && (error.message || error.stack))) {
      ++errors

      log({ url, message, file, line, column, error })
    }
  }
}
